"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _beam = require("beam");
var _NavBar = require("./NavBar");
var _detectBrowser = require("detect-browser");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useStyles = (0, _beam.makeStyles)(theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    height: theme.spacing(6)
  },
  menuPanel: {
    position: 'absolute',
    top: theme.spacing(6)
  },
  menuItem: {
    fontSize: 14,
    display: 'flex'
  },
  multiColMenuContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1
  },
  navButton: {
    cursor: 'pointer',
    minWidth: theme.spacing(4),
    color: theme.palette.navigationTextColor,
    // TODO: provide `navigationTextColor` from the interface used by `theme.palette`
    borderRadius: 0,
    textTransform: 'none',
    padding: theme.spacing(0, 1),
    opacity: '0.7',
    '&:hover': {
      opacity: '1'
    },
    '&:active': {
      borderBottom: `solid 2px ${theme.palette.navigationTextColor}`,
      // TODO: provide `navigationTextColor` from the interface used by `theme.palette`
      opacity: '1'
    }
  }
}));
const NavButton = /*#__PURE__*/(0, _react.forwardRef)(({
  url,
  external,
  isCurrent,
  withAutoQaId,
  children,
  menuItem
}, ref) => {
  const classes = useStyles();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [open, setOpen] = (0, _react.useState)(false);
  const handleMouseEnter = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Transform the menuData into the corresponding component
  const mapMenuDataColToMenuItemComponent = menuData => {
    const menuItemTemplate = item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.MenuItem, {
      className: classes.menuItem,
      component: 'a',
      href: item.url,
      target: item.external ? '_blank' : undefined,
      rel: item.external ? 'noopener' : undefined,
      "data-testid": withAutoQaId ? `NavButton-${item.key}` : null,
      children: t(item.key)
    }, item.key);
    if (Array.isArray(menuData)) {
      return menuData.map(item => menuItemTemplate(item));
    } else {
      return !!menuData ? menuItemTemplate(menuData) : null;
    }
  };

  // Each column goes into a container div which is flexxin' so that it can be well aligned
  // (and so we dont have to do relative positioning hacks)
  const renderChildItems = menuItems => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.multiColMenuContainer,
      children: menuItems.map((col, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [" ", mapMenuDataColToMenuItemComponent(col), " "]
      }, i))
    });
  };

  /* Internet Explorer renders the top left corner of the <Paper> element at the bottom right
   * corner of it's parent element making it very difficult to hover over. This function returns
   * styling to shift the position of the element to better line up with its parent.
   * Works in Internet Explorer 6-11. http://jira/browse/SAAS-51568 */
  const browserDependentStyling = () => {
    const browserName = (0, _detectBrowser.detect)()?.name;
    if (browserName === 'ie') {
      return {
        left: 0
      }; // IE adds something called offset, in addition to margin & padding (hence the top left corner rendering issue). By setting left: 0, the offset is removed
    } else {
      return {};
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: classes.root,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleClose,
    children: [menuItem.url && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_beam.Button, {
      ref: ref,
      className: classes.navButton,
      component: 'a',
      href: url,
      target: external ? '_blank' : undefined,
      rel: external ? 'noopener' : undefined,
      "data-testid": withAutoQaId ? `NavButton-${menuItem.key}` : null,
      children: [menuItem.key !== _NavBar.DASHBOARD_KEY && t(menuItem.key) /* TODO: remove `any` and fix type error */, children]
    }), open && Object.prototype.hasOwnProperty.call(menuItem, 'children') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.Paper, {
      className: classes.menuPanel,
      style: browserDependentStyling(),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.MenuList, {
        children: renderChildItems(menuItem.children)
      })
    })]
  });
});
var _default = exports.default = NavButton;
//# sourceMappingURL=NavButton.js.map